import { render } from "./product-grid.vue?vue&type=template&id=0efe67e3"
import script from "./product-grid.vue?vue&type=script&lang=js"
export * from "./product-grid.vue?vue&type=script&lang=js"

import "./product-grid.vue?vue&type=style&index=0&id=0efe67e3&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__